import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment.prod";
import { DataService } from "./data.service";

@Injectable()
export class GSDService {

    getmanagerEventRoute = '/api/manager/';
    getfleetEventRoute = '/api/fleet/';
    getcustomerEventRoute = '/api/customer/';
    getdriverEventRoute = '/api/driver/';
    getproductEventRoute = '/api/product/';
    getloadEventRoute = '/api/load/';
    getmonthlytargetEventRoute = '/api/monthlytarget/';
    getordersEventRoute = '/api/order/';
    gettrailerEventRoute = '/api/trailer/'
    getfuelLogEventRoute = '/api/fuelLog/';
    getdrivervalidationEventRoute = '/api/driver/drivervalidation/'
    gettripdocumenttrackerEventRoute = '/api/tripdocumenttracker/';
    getWorkingcalendarRoute = '/api/config/';
    getCountryEventRoute = '/api/country/';
    getProvinceEventRoute = '/api/province/';

    constructor(private dataService: DataService,
        private http: HttpClient) {
    };



    saveManager(result: any) {
        return this.dataService.post('/api/manager/', result).map(response => {
            this.dataService.clearRouteCache(this.getmanagerEventRoute);
            return response;
        });
    }

    getManagerById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/manager/' + id, refresh);
    }

    getManager(refresh: boolean) {
        return this.dataService.getData('/api/manager', refresh);
    }

    deleteManager(id: number) {
        return this.dataService.delete('/api/manager/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getmanagerEventRoute);
            return response;
        });
    }

    getProvince(refresh: Boolean) {
        return this.dataService.getData('/api/common/Province', refresh);
    }

    getmanagerLookup(refresh: Boolean) {
        return this.dataService.getData('/api/manager/LookUp/Manager', refresh);
    }

    getgroupLookup(refresh: Boolean) {
        return this.dataService.getData('/api/fleet/grouplookUp', refresh);
    }

    getcustomerLookup(refresh: Boolean) {
        return this.dataService.getData('/api/customer/customerlookup', refresh);
    }
    getbrokerLookup(refresh: Boolean) {
        return this.dataService.getData('/api/broker/brokerlookup', refresh);
    }


    getdriverLookup(refresh: Boolean) {
        return this.dataService.getData('/api/driver/driverlookup', refresh);
    }

    getsiteLookup(refresh: Boolean) {
        return this.dataService.getData('/api/fuellingpoint/fuellingPointlookup', refresh);
    }

    saveFleet(result: any) {
        return this.dataService.post('/api/fleet/', result).map(response => {
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }

    getFleet(refresh: boolean) {
        return this.dataService.getData('/api/fleet', refresh);
    }

    getFleetById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/fleet/' + id, refresh);
    }

    deleteFleet(id: number) {
        return this.dataService.delete('/api/fleet/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }

    advanceSearchFleet(result: any) {

        return this.dataService.post('/api/fleet/advancedsearch/', result).map(response => {
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }

    saveCustomer(result: any) {
        return this.dataService.post('/api/customer/', result).map(response => {
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }
    saveBroker(result: any) {
        return this.dataService.post('/api/broker/', result).map(response => {
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }

    getCustomer(refresh: boolean) {
        return this.dataService.getData('/api/customer/', refresh);
    }
    getBroker(refresh: boolean) {
        return this.dataService.getData('/api/broker/', refresh);
    }

    getBrokerById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/broker/' + id, refresh);
    }
    getCustomerById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/customer/' + id, refresh);
    }

    deleteCustomers(id: number) {
        return this.dataService.delete('/api/customer/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }
    deleteBrokers(id: number) {
        return this.dataService.delete('/api/broker/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }

    dectivateActivate(id: number, status: number) {
        return this.dataService.post('/api/customer/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }
    brokerdectivateActivate(id: number, status: number) {
        return this.dataService.post('/api/broker/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }

    advanceSearchCustomer(result: any) {
        return this.dataService.post('/api/customer/advancesearch/', result).map(response => {
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }
    advanceSearchBroker(result: any) {
        return this.dataService.post('/api/broker/advancesearch/', result).map(response => {
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }

    advanceSearchDriver(result: any) {
        return this.dataService.post('/api/driver/advancesearch/', result).map(response => {
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }

    advanceSearchManager(result: any) {
        return this.dataService.post('/api/manager/advancesearch/', result).map(response => {
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }
    advanceSearchMonthlyTarget(result: any) {
        return this.dataService.post('/api/monthlytarget/advancesearch/', result).map(response => {
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }

    advanceSearchSite(result: any) {
        return this.dataService.post('/api/fuellingpoint/advancesearch', result).map(response => {
            this.dataService.clearRouteCache(this.getfleetEventRoute);
            return response;
        });
    }

    saveDriver(result: any) {
        return this.dataService.post('/api/driver/', result).map(response => {
            this.dataService.clearRouteCache(this.getdriverEventRoute);
            return response;
        });
    }

    saveGroup(result: any) {
        return this.dataService.post('/api/fleet/fleetgrouping', result).map(response => {
            this.dataService.clearRouteCache(this.getdriverEventRoute);
            return response;
        });
    }

    getGenderType(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/gendertype', refresh);
    }

    getMonthType(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/monthtype', refresh);
    }

    getDriver(refresh: boolean) {
        return this.dataService.getData('/api/driver', refresh);
    }

    getDriverById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/driver/' + id, refresh);
    }

    deleteDriver(id: number) {
        return this.dataService.delete('/api/driver/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getdriverEventRoute);
            return response;
        });
    }

    saveProduct(result: any) {
        return this.dataService.post('/api/product/', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    getProduct(refresh: boolean) {
        return this.dataService.getData('/api/product', refresh);
    }

    getProductById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/product/' + id, refresh);
    }

    deleteProduct(id: number) {
        return this.dataService.delete('/api/product/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    deleteunallocated(id: number) {
        return this.dataService.delete('/api/order/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    saveLoadType(result: any) {
        return this.dataService.post('/api/load/', result).map(response => {
            this.dataService.clearRouteCache(this.getloadEventRoute);
            return response;
        });
    }

    getLoadType(refresh: boolean) {
        return this.dataService.getData('/api/load', refresh);
    }

    getLoadById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/load/' + id, refresh);
    }

    deleteLoad(id: number) {
        return this.dataService.delete('/api/load/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getloadEventRoute);
            return response;
        });
    }


    saveMonthlyTarget(result: any) {
        return this.dataService.post('/api/monthlytarget/', result).map(response => {
            this.dataService.clearRouteCache(this.getmonthlytargetEventRoute);
            return response;
        });
    }


    getMonthlyTarget(data: any, refresh: boolean) {
        return this.dataService.getData('/api/monthlytarget/getallmonthlytarget' + '/' + data.month + '/' + data.year, refresh);
    }

    getMonthlyTargetById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/monthlytarget/' + id, refresh);
    }

    deleteMonthlyTarget(id: number) {
        return this.dataService.delete('/api/monthlytarget/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getmonthlytargetEventRoute);
            return response;
        });
    }

    saveFuellingpoint(result: any) {
        return this.dataService.post('/api/fuellingpoint/', result).map(response => {
            this.dataService.clearRouteCache(this.getmonthlytargetEventRoute);
            return response;
        });
    }

    getFuellingpoint(refresh: boolean) {
        return this.dataService.getData('/api/fuellingpoint', refresh);
    }

    getFuellingpointById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/fuellingpoint/' + id, refresh);
    }

    deleteFuellingpoint(id: number) {
        return this.dataService.delete('/api/fuellingpoint/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getmonthlytargetEventRoute);
            return response;
        });
    }

    getFleetLookupById(fleetGroupId, refresh: Boolean) {
        return this.dataService.getData('/api/fleet/fleetlookUp/' + fleetGroupId, refresh);
    }

    getFleetLookup(refresh: Boolean) {
        return this.dataService.getData('/api/fleet/fleetlookUp', refresh);
    }

    gettrailerNoLookup(refresh: Boolean) {
        return this.dataService.getData('/api/trailer/LookupTrailerNo', refresh);
    }

    getFleetLookUpbyid(data: any, refresh: boolean) {
        return this.dataService.getData('/api/fleet/fleetcompetency/' + data, refresh);
    }

    getRoleLookup(refresh: Boolean) {
        return this.dataService.getData('/api/common/Role', refresh);
    }

    getpalletNoteLookup(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/pallettype', refresh);
    }

    getloadLookup(refresh: Boolean) {
        return this.dataService.getData('/api/load/loadlookup', refresh);
    }

    getproductLookup(refresh: Boolean) {
        return this.dataService.getData('/api/product/productlookup', refresh);
    }

    getDriverLookup(refresh: Boolean) {
        return this.dataService.getData('/api/driver/driverlookup', refresh);
    }



    getrateTypeLookup(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/ratetype', refresh);
    }

    savePlanningLog(result: any) {
        return this.dataService.post('/api/order/', result).map(response => {
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }

    saveMultiLeg(result: any) {
        return this.dataService.post('/api/multileg', result).map(response => {
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }

    saveMultiCustomer(result: any) {
        return this.dataService.post('/api/multicustomer', result).map(response => {
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }

    download(file: string | undefined): Observable<Blob> {
        return this.http.get(`${environment.apiBaseUrl}/files/${file}`, {
            responseType: 'blob'
        });
    }

    getPlanningLog(data: any, refresh: boolean) {
        const hasFleetGroupId = data.fleetGroupId !== undefined && data.fleetGroupId !== null;
        const route = '/api/order/' + data.isPlanningLog + '/' + data.month + '/' + data.year
            + (hasFleetGroupId ? '/' + data.fleetGroupId : '');
        return this.dataService.getData(route, refresh);
    }
    getTrips(data: any, refresh: boolean) {
        return this.dataService.getData('/api/report/TripList/' + data.month + '/' + data.year, refresh);
    }

    getRefuel(data: any, refresh: boolean) {
        return this.dataService.getData('/api/report/RefuelList/' + data.month + '/' + data.year, refresh);
    }

    getDistance(data: any, refresh: boolean) {
        return this.dataService.getData('/api/report/DistanceList/' + data.month + '/' + data.year, refresh);
    }

    getTripstatus(data: any, refresh: boolean) {
        return this.dataService.getData('/api/report/TripStatus/' + data.month + '/' + data.year, refresh);
    }

    getInvoiceExport(data: any, refresh: boolean) {
        return this.dataService.getData('/api/order/Export/' + data.month + '/' + data.year + '/' + data.orderId, refresh);
    }

    getPlanningLogById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/order/' + id, refresh);
    }

    getMultiCustomerPlanningLogById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/multicustomer/' + id, refresh);
    }

    getPlanningLogMultiLegById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/multileg/' + id, refresh);
    }

    deletePlanningLog(id: number) {
        return this.dataService.delete('/api/order/delete/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }

    updatePlanningLog(id: number, status: number) {
        return this.dataService.post('/api/order/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }

    exportUpdate(result: any) {
        return this.dataService.post('/api/order/ExportedList', result).map(response => {
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }

    updateSentforInvoicing(id: number, sentForInvoicing: any) {
        return this.dataService.post('/api/report/update/' + id + '/' + sentForInvoicing, null).map(response => {
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }

    getYesNoLookup(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/yesornotype', refresh);
    }

    getInvoicedLookup(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/invoicedTyped', refresh);
    }

    getUnauthorizedLookup(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/report/unauthorized/' + data.month + '/' + data.year, refresh);
    }


    saveTrailer(result: any) {
        return this.dataService.post('/api/trailer/', result).map(response => {
            this.dataService.clearRouteCache(this.gettrailerEventRoute);
            return response;
        });
    }

    getTrailer(refresh: boolean) {
        return this.dataService.getData('/api/trailer', refresh);
    }

    getTrailerById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/trailer/' + id, refresh);
    }

    deleteTrailer(id: number) {
        return this.dataService.delete('/api/trailer/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.gettrailerEventRoute);
            return response;
        });
    }

    getLoadingList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/common/LoadingTownList/' + data.month + '/' + data.year, refresh);

    }

    getOffLoadingList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/common/OffLoadingTownList/' + data.month + '/' + data.year, refresh);

    }

    gettrailerLookup(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/trailertype', refresh);
    }

    getStatusLookup(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/statusType', refresh);
    }

    advanceSearchtrailer(result: any) {

        return this.dataService.post('/api/trailer/advancesearch/', result).map(response => {
            this.dataService.clearRouteCache(this.gettrailerEventRoute);
            return response;
        });
    }

    advanceSearchOrders(result: any) {

        return this.dataService.post('/api/order/advancesearch/', result).map(response => {
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }

    getDashBoardData(refresh: Boolean) {
        return this.dataService.getData('/api/order/DashBoardOrderCount', refresh);
    }

    allocateOrder(result: any) {
        return this.dataService.post('/api/order/allocateOrder/', result).map(response => {
            this.dataService.clearRouteCache(this.getordersEventRoute);
            return response;
        });
    }


    getRefeulLocation(refresh: Boolean) {
        return this.dataService.getData('/api/fuellingpoint/fuellingPointlookup', refresh);
    }

    saveFuelLog(result: any) {
        return this.dataService.post('/api/fuelLog/', result).map(response => {
            this.dataService.clearRouteCache(this.getfuelLogEventRoute);
            return response;
        });
    }

    saveTripdocumenttrackerDuplicate(result: any) {
        return this.dataService.post('/api/tripdocumenttracker/envelopevalidation', result).map(response => {
            return response;
        });
    }
    savePlanningFeeltDuplicate(result: any) {
        return this.dataService.post('/api/order/OrderFleetValidation', result).map(response => {
            return response;
        });
    }

    getFuelLog(data: any, refresh: boolean) {
        return this.dataService.getData('/api/fuelLog' + '/' + data.month + '/' + data.year, refresh);
    }

    getFuelLogById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/fuelLog/' + id, refresh);
    }

    deleteFuelLog(id: number) {
        return this.dataService.delete('/api/fuelLog/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getfuelLogEventRoute);
            return response;
        });
    }

    advanceSearchfuelLog(result: any) {
        return this.dataService.post('/api/fuelLog/advancesearch/', result).map(response => {
            this.dataService.clearRouteCache(this.getfuelLogEventRoute);
            return response;
        });
    }

    getfleetTypeLookup(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/fleettype', refresh);
    }

    getLastId(refresh: Boolean) {
        return this.dataService.getData('/api/common/LastId', refresh);
    }

    getFuelLastId(refresh: Boolean) {
        return this.dataService.getData('/api/fuelLog/FuelLogTransRef', refresh);
    }


    getDriverByID(id: number) {
        return this.dataService.getRecord('/api/order/driverLicenseExpiry?driverId=' + id);
    }


    checkDuplicateFleet(result: any) {
        return this.dataService.post('/api/fleet/fleetvalidation/', result).map(response => {
            this.dataService.clearRouteCache(this.getfuelLogEventRoute);
            return response;
        });
    }

    checkDuplicateCustomer(result: any) {
        return this.dataService.post('/api/customer/customervalidation/', result).map(response => {
            let url = '/api/customer/customervalidation/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }
    checkDuplicateBroker(result: any) {
        return this.dataService.post('/api/broker/brokervalidation', result).map(response => {
            let url = '/api/customer/brokervalidation/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }

    checkDuplicateBrokerName(result: any) {
        return this.dataService.post('/api/broker/brokernamevalidation', result).map(response => {
            let url = '/api/customer/brokervalidation/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }
    checkDuplicatePN(result: any) {
        return this.dataService.post('/api/product/productvalidation/', result).map(response => {
            this.dataService.clearRouteCache(this.getfuelLogEventRoute);
            return response;
        });
    }

    checkDuplicateLN(result: any) {
        return this.dataService.post('/api/load/loadvalidation/', result).map(response => {
            this.dataService.clearRouteCache(this.getfuelLogEventRoute);
            return response;
        });
    }

    checkDuplicateSiteName(result: any) {
        return this.dataService.post('/api/fuellingpoint/fuelingpointvalidation/', result).map(response => {
            let url = '/api/fuellingpoint/fuelingpointvalidation/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }

    checkDuplicateEmail(result: any) {
        return this.dataService.post('/api/user/uservalidation/', result).map(response => {
            let url = '/api/user/uservalidation/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }

    checkDuplicateOrders(result: any) {

        return this.dataService.post('/api/order/ordervalidation/', result).map(response => {
            let url = '/api/order/ordervalidation/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }

    checkDuplicateTrailer(result: any) {
        return this.dataService.post('/api/trailer/trailervalidation/', result).map(response => {
            this.dataService.clearRouteCache(this.getfuelLogEventRoute);
            return response;
        });
    }

    checkDuplicateDriver(result: any) {
        return this.dataService.post('/api/driver/drivervalidation/', result).map(response => {
            this.dataService.clearRouteCache(this.getdrivervalidationEventRoute);
            return response;
        });
    }

    checkDuplicatemanagerEmail(result: any) {
        return this.dataService.post('/api/manager/managervalidation/', result).map(response => {
            let url = '/api/manager/managervalidation/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }


    orderBudgetError(data: any, refresh: boolean) {
        return this.dataService.getData('/api/order/orderBudgetError/' + data.fleetId, refresh);
    }

    emptyKmsCheck(data: any, refresh: boolean) {
        return this.dataService.getData('/api/order/EmptyKMSCheck/' + data.fleetId + '/' + data.currentOnLoading, refresh);
    }

    emptyCheck(data: any, refresh: boolean) {
        return this.dataService.getData('/api/order/PreviousEmptyKMS/' + data.fleetId + '/' + data.PlannedLoadingDate, refresh);
    }
    PreviouOdoCheck(data: any, refresh: boolean) {
        return this.dataService.getData('/api/fuelLog/PreviouOdo/' + data.fleetId + '/' + data.DateOfFueling, refresh);
    }
    fleetpreviouslitreCheck(data: any, refresh: boolean) {
        return this.dataService.getData('/api/fuelLog/TankCapacityValue/' + data.fleerId, refresh);
    }
    fuelWarning(data: any, refresh: boolean) {
        return this.dataService.getData('/api/fuelLog/FleetFuelWarning/' + data.fleetId + '/' + data.DateOfFueling, refresh);
    }

    getManagerbyFleet(data: any, refresh: boolean) {
        return this.dataService.getData('/api/fleet/FleetNo?FleetId=' + data.fleetId, refresh);
    }

    monthlyTargetValidation(data: any, refresh: boolean) {
        return this.dataService.getData('/api/monthlytarget/FleetList?monthType=' + data.month + '&' + 'Year=' + data.year, refresh);
    }


    saveTripdocumenttracker(result: any) {
        return this.dataService.post('/api/tripdocumenttracker/', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    tripReport(result: any) {
        return this.dataService.post('/api/report/tripreport', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    refuelReport(result: any) {
        return this.dataService.post('/api/report/refuelreport', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }
    emptyTruckReport(result: any) {
        return this.dataService.post('/api/report/emptytruckreport', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    distanceReport(result: any) {
        return this.dataService.post('/api/report/distancereport', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    tripStatusReport(result: any) {
        return this.dataService.post('/api/report/tripstatusreport', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    podReport(result: any) {
        return this.dataService.post('/api/report/podreport', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    statusLookup(result: any) {
        return this.dataService.post('/api/report/StatusLookup', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }
    TruckLookup(result: any) {
        return this.dataService.post('/api/report/RefuelfleetLookup', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }
    DriverLookup(result: any) {
        return this.dataService.post('/api/report/RefueldriverLookup', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }
    RefuelLookup(result: any) {
        return this.dataService.post('/api/report/RefuellocationLookup', result).map(response => {
            this.dataService.clearRouteCache(this.getproductEventRoute);
            return response;
        });
    }

    getTripdocumenttracker(refresh: boolean) {
        return this.dataService.getData('/api/tripdocumenttracker', refresh);
    }

    getTripdocumenttrackerById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/tripdocumenttracker/tripDocumentEdit/' + id, refresh);
    }

    deleteTripdocumenttracker(id: number) {
        return this.dataService.delete('/api/tripdocumenttracker/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }

    advanceSearchtripDoc(result: any) {

        return this.dataService.post('/api/tripdocumenttracker/advancesearch', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }
    getFleets(result: any) {
        return this.dataService.post('/api/order/orderlookup', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }

    getEmptyFleets(result: any) {
        return this.dataService.post('/api/order/emptytrucks', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }

    getLoading(result: any) {
        return this.dataService.post('/api/report/LoadingTown', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }

    getOffLoading(result: any) {
        return this.dataService.post('/api/report/OffLoadingTown', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }
    getFleetDD(result: any) {
        return this.dataService.post('/api/report/Fleet', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }

    getDriverDD(result: any) {
        return this.dataService.post('/api/report/Driver', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }

    getCustomerDD(result: any) {
        return this.dataService.post('/api/report/Customer', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }


    getDrivers(result: any) {
        return this.dataService.post('/api/order/driverlookup', result).map(response => {
            this.dataService.clearRouteCache(this.gettripdocumenttrackerEventRoute);
            return response;
        });
    }

    getAllocationDetailList(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/tripdocumenttracker/autoFetch/' + data.driverId + '/' + data.envNo, refresh);
    }

    getTripNoautoFetch(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/tripdocumenttracker/autoFetch/' + data.tripNo, refresh);
    }

    validateFile(data) {
        return this.dataService.post('/api/workingcalendar/excelvalidate', data);
    }

    saveExcel(result: any) {
        return this.dataService.post('/api/workingcalendar/importsave', result).map(response => {
            return response;
        });
    }

    delete(id: number) {
        return this.dataService.delete('/api/tripdocumenttracker/tripDocumentDetail/' + id).map(response => {
            this.dataService.clearCache();
            return response;
        });
    }

    deleteMultiCustomer(id: number) {
        return this.dataService.delete('/api/multicustomer/multicustomerList/' + id).map(response => {
            this.dataService.clearCache();
            return response;
        });
    }

    validateload(data) {

        return this.dataService.post('/api/load/excelValidation', data);
    }
    validatebroker(data) {

        return this.dataService.post('/api/broker/excelvalidate', data);
    }
    validatedriver(data) {

        return this.dataService.post('/api/driver/excelvalidate', data);
    }

    validatecustomer(data) {

        return this.dataService.post('/api/customer/excelvalidate', data);
    }

    validatefuel(data) {

        return this.dataService.post('/api/fuellingpoint/excelvalidate', data);
    }
    validatefleet(data) {

        return this.dataService.post('/api/fleet/excelvalidate', data);
    }
    validatemanager(data) {

        return this.dataService.post('/api/manager/excelvalidate', data);
    }

    validateproduct(data) {

        return this.dataService.post('/api/product/excelvalidate', data);
    }
    validatetrailer(data) {

        return this.dataService.post('/api/trailer/excelvalidate', data);
    }
    validateMonthlyTargetFile(data) {

        return this.dataService.post('/api/monthlytarget/excelvalidate', data);
    }
    saveFuelPoint(result: any) {
        return this.dataService.post('/api/fuellingpoint/importsave', result).map(response => {
            return response;
        });
    }
    saveTrailerExcel(result: any) {
        return this.dataService.post('/api/trailer/importsave', result).map(response => {
            return response;
        });
    }

    saveManagerExcel(result: any) {
        return this.dataService.post('/api/manager/importsave', result).map(response => {
            return response;
        });
    }

    saveMTExcel(result: any) {
        return this.dataService.post('/api/monthlytarget/importSave', result).map(response => {
            return response;
        });
    }
    saveProductExcel(result: any) {
        return this.dataService.post('/api/product/excelimport', result).map(response => {
            return response;
        });
    }
    saveLoadExcel(result: any) {
        return this.dataService.post('/api/load/importSave', result).map(response => {
            return response;
        });
    }

    saveDriverExcel(result: any) {
        return this.dataService.post('/api/driver/excelimport', result).map(response => {
            return response;
        });
    }

    saveBrokerExcel(result: any) {
        return this.dataService.post('/api/broker/importSave', result).map(response => {
            return response;
        });
    }

    saveFleetExcel(result: any) {
        return this.dataService.post('/api/fleet/importSave', result).map(response => {
            return response;
        });
    }

    saveCustomerExcel(result: any) {
        return this.dataService.post('/api/customer/importSave', result).map(response => {
            return response;
        });
    }
    updateHoliday(result: any) {
        return this.dataService.post('/api/workingcalendar/updatemultipler', result).map(response => {
            let url = '/api/workingcalendar/updatemultipler/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }
    getDetailedIncomeReport(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/report/detailedreport/' + data.month + '/' + data.year + (data.fleetGroupId ? '/' + data.fleetGroupId : data.fleetId ? "/0" : '') + (data.fleetId ? '/' + data.fleetId : data.fleetGroupId ? "/0" : ''), refresh);
    }
    getEmptyListReport(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/report/EmptyTruckList/' + data.type + '/' + data.month + '/' + data.year, refresh);
    }
    getdashboardCPK(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashboard/dashboardchartCPK/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }
    getdashboardLineChart(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashBoard/linechart/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }
    getRevVsBudChart(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashboard/revenuevsbudget/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }
    getMTDRevVsBudChart(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashBoard/MTDRevenueNew/' + data.month + '/' + data.year + (data.fleetGroupId ? '/' + data.fleetGroupId : data.fleetId ? "/0" : '') + (data.fleetId ? '/' + data.fleetId : data.fleetGroupId ? "/0" : ''), refresh);
    }
    getPODTurnaround(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/report/PODTurnaround/' + data.month + '/' + data.year, refresh);
    }
    getbudgetactuallineChart(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashBoard/RevenuevsActual/' + data.monthType + '/' + data.yearType + (data.fleetId ? '?fleetId=' + data.fleetId : ''), refresh);
    }

    getTripDocChart(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/tripdocumenttracker/tripdocumenttracker/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }

    getPalletChart(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashBoard/palletchart/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }
    getLitreCost(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/fuelLog/LitreCost/' + data.litre + '/' + data.cost, refresh);
    }

    getdailyTripsChart(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashboard/dailytrips/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }

    getOrderData(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashboard/OrderTypeCountChart/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }

    getLoadConsData(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/order/GetFlaggCount/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }
    getInvoicedData(data: any, refresh: Boolean) {
        let route = '/api/order/InvoiceList/' + data.Invoiced + '/' + data.month + '/' + data.year;
        const params = [];

        if (data.fleetGroupId) {
            params.push('fleetGroupId=' + encodeURIComponent(data.fleetGroupId));
        }
        if (data.fleetId) {
            params.push('fleetId=' + data.fleetId);
        }
        if (params.length > 0) {
            route += '?' + params.join('&');
        }

        return this.dataService.getData(route, refresh);
    }

    getCalendarList(refresh: boolean) {
        return this.dataService.getData('/api/workingcalendar', refresh);
    }

    getYearList(refresh: Boolean) {
        return this.dataService.getData('/api/common/YearList', refresh);
    }
    get(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashBoard/MTDRevenue/' + data.month + '/' + data.year, refresh);
    }

    deleteHoliday(id: number) {
        return this.dataService.delete('/api/workingcalendar/' + id).map(response => {
            let url = '/api/workingcalendar/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }

    saveHoliday(result: any) {
        return this.dataService.post('/api/workingcalendar/', result).map(response => {
            let url = '/api/workingcalendar/'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }

    getEmptyTrucks(key, refresh: Boolean) {
        return this.dataService.getData('/api/config/configDetail/' + key, refresh);
    }
    getWorkingcalendar(key, refresh: Boolean) {
        return this.dataService.getData('/api/config/configDetail/' + key, refresh);
    }
    getWorkingcalendarId(key, refresh: boolean) {
        return this.dataService.getData('/api/config/configDetail/' + key, refresh);
    }

    getOdoId(key, refresh: boolean) {
        return this.dataService.getData('/api/config/configDetail/' + key, refresh);
    }
    getFCId(key, refresh: boolean) {
        return this.dataService.getData('/api/config/configDetail/' + key, refresh);
    }
    getLoadId(key, refresh: boolean) {
        return this.dataService.getData('/api/config/configDetail/' + key, refresh);
    }
    getOTLId(key, refresh: boolean) {
        return this.dataService.getData('/api/config/configDetail/' + key, refresh);
    }
    getCustomerId(key, refresh: boolean) {
        return this.dataService.getData('/api/config/configDetail/' + key, refresh);
    }


    saveWorkingcalendar(result: any) {
        return this.dataService.post('/api/config/Update', result).map(response => {
            let url = '/api/config/Update'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }
    saveOdoOutstanding(result: any) {
        return this.dataService.post('/api/config/Update', result).map(response => {
            let url = '/api/config/Update'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }
    saveOrdersTonsLoaded(result: any) {
        return this.dataService.post('/api/config/Update', result).map(response => {
            let url = '/api/config/Update'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }

    saveUtility(result: any) {
        return this.dataService.post('/api/config/Update', result).map(response => {
            let url = '/api/config/Update'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }
    saveLoadConsOutstanding(result: any) {
        return this.dataService.post('/api/config/Update', result).map(response => {
            let url = '/api/config/Update'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }
    saveEmptyTruck(result: any) {
        return this.dataService.post('/api/config/Update', result).map(response => {
            let url = '/api/config/Update'
            this.dataService.clearRouteCache(url);
            return response;
        });
    }

    getODOOustandingCount(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/fuelLog/getODOOustandingCount/' + data.monthType + '/' + data.yearType + (data.fleetGroupId ? '/' + data.fleetGroupId : ''), refresh);
    }
    getTimelineChatData(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/dashBoard/TruckTimeLine/' + data.monthType + '/' + data.yearType + '/' + data.fleetGroupId + (data.fleetId ? '?fleetId=' + data.fleetId : ''), refresh);
    }

    trailerdectivateActivate(id: number, status: number) {
        return this.dataService.post('/api/trailer/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }
    fleetdectivateActivate(id: number, status: number) {
        return this.dataService.post('/api/fleet/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }
    fuellogsdectivateActivate(id: number, status: number) {
        return this.dataService.post('/api/fuelLog/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getcustomerEventRoute);
            return response;
        });
    }

    getPalletsummary(data: any, refresh: boolean) {
        return this.dataService.getData('/api/order/palletsummary/' + data.month + '/' + data.year, refresh);
    }
    getTonsLoadedKeyValue(refresh: Boolean) {
        return this.dataService.getData('/api/config/configDetail/' + 'TONS_LOADED', refresh);
    }
    getLitreLoadedKeyValue(refresh: Boolean) {
        return this.dataService.getData('/api/config/configDetail/' + 'LITERS_LOADED', refresh);
    }

    saveCountry(data: any, refresh: boolean) {
        return this.dataService.post('/api/country', data);
    }

    getCountryList(refresh: boolean) {
        return this.dataService.getData('/api/country', refresh);
    }

    editCountry(id: any, refresh: boolean) {
        return this.dataService.getData(`/api/country/${id}`, refresh);
    }

    deleteCountry(id: number) {
        return this.dataService.delete('/api/country/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getCountryEventRoute);
            return response;
        });
    }

    getProvinceList(data: any, refresh: boolean) {
        return this.dataService.getData("/api/province", refresh);
    }
    saveProvince(data: any, refresh: boolean) {
        return this.dataService.post("/api/province", data);
    }
    editProvince(id: any, refresh: boolean) {
        return this.dataService.getData(`/api/province/${id}`, refresh);
    }
    deleteProvince(id: number) {
        return this.dataService.delete('/api/province/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getProvinceEventRoute);
            return response;
        });
    }


    getGroupList(data: any, refresh: boolean) {
        return this.dataService.getData("/api/fleet/grouplookUp", refresh);
    }
    saveGroupList(payload: any, refresh: boolean) {
        return this.dataService.post("/api/fleet/group", payload);
    }
    editGroup(id: any, refresh: boolean) {
        return this.dataService.getData(`/api/fleet/getgroup/${id}`, refresh);
    }
    deleteGroup(key: number) {
        return this.dataService
            .delete("/api/fleet/deleteGroupById/" + key)
            .map((response) => {
                this.dataService.clearCache();
                this.dataService.clearRouteCache(this.getCountryEventRoute);
                return response;
            });
    }
    getdashboardfleetdetails(data: any, refresh: boolean) {
        return this.dataService.getData('/api/dashBoard/GetFleetCount/' + data.monthType + '/' + data.yearType + (data.fleetId ? '?fleetId=' + data.fleetId : ''), refresh);
    }
}
